"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryLanguageAssignmentsForRegion = void 0;
var buildInternalRoute_1 = require("./buildInternalRoute");
var environments_1 = require("./environments");
var getCountryLanguageAssignmentsForRegion = function (regionCode, localeIdentifiers, existingPagesInOtherLocaleIdentifiers) {
    if (!existingPagesInOtherLocaleIdentifiers) {
        return [];
    }
    var hostUrl = (0, environments_1.getMarketingSiteHostUrlForRegion)(regionCode);
    var activeLocaleIdentifiersForRegion = localeIdentifiers.filter(function (localeIdentifier) { var _a, _b; return ((_b = (_a = localeIdentifier === null || localeIdentifier === void 0 ? void 0 : localeIdentifier.country) === null || _a === void 0 ? void 0 : _a.region) === null || _b === void 0 ? void 0 : _b.regionCode) === regionCode; });
    var countryLanguageAssignmentsForRegion = existingPagesInOtherLocaleIdentifiers.map(function (existingPage) {
        var page = existingPage.node;
        return activeLocaleIdentifiersForRegion
            .filter(function (activeLocale) {
            return activeLocale.languageCode === page.localeIdentifier.languageCode;
        })
            .map(function (locale) { return ({
            pageUrl: "".concat(hostUrl).concat((0, buildInternalRoute_1.buildInternalRoute)(page, locale)),
            localeId: locale.localeId,
            isRegionMasterPrimaryLanguage: page.localeIdentifier.isRegionMasterPrimaryLanguage,
        }); });
    });
    return countryLanguageAssignmentsForRegion.flat();
};
exports.getCountryLanguageAssignmentsForRegion = getCountryLanguageAssignmentsForRegion;
